import {UIGameMechanic} from 'code/client/shared/scripts/ui_game/UIGameEventController'
import {GameColor} from '../../../../shared/scripts/GameColor'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {SectionView} from '../../../../shared/scripts/ui_canvas_engine/SectionView'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGamePlayerInformationView, UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {GameStateEnums} from '../../../../../shared/GameEnums'

export class UIMGamePlayerInformationDropdownController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly container: UIGamePlayerInformationView
    private readonly numberOfLayers: number
    private readonly offset: number = 0
    private readonly isLeftAligned: boolean
    private readonly lineMarkers: SectionBgView[] = []
    private currentActiveLayer: UIPlayerAdditionalInformationLayer = UIPlayerAdditionalInformationLayer.Layer0
    readonly dropdownInformationViews: SectionView[]

    constructor(uiGameManager: UIGameManager, container: UIGamePlayerInformationView, leftAligned: boolean, offset: number) {
        this.uiGameManager = uiGameManager
        this.numberOfLayers = container.cityWallPlayerState ? 4 : 2
        this.isLeftAligned = leftAligned
        this.offset = offset
        this.dropdownInformationViews = []
        this.container = container
        this.createDropdownInformationView()
        this.createDropdownLineMarkers()

        this.currentActiveLayer = UIPlayerAdditionalInformationLayer.Layer0
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.dropdownInformationViews[this.currentActiveLayer].visible = true
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.PlayerInformationViewClicked: this.incrementActiveLayer(); break
            default: break
        }
    }

    private createDropdownLineMarkers() {
        const margin = this.uiGameManager.canvasController.margin

        const lineHeight = margin
        const lineWidth = this.numberOfLayers < 3 ? this.uiGameManager.canvasController.itemSize * 0.5 : this.uiGameManager.canvasController.itemSize * 0.32
        const lineY = this.container.height - 4 * margin - lineHeight
        const totalLineWidth = lineWidth * this.numberOfLayers - this.offset
        const dropdownWidth = this.dropdownInformationViews[0].width
        const totalMargin = margin * (this.numberOfLayers - 1)
        let lineX = (dropdownWidth - totalLineWidth - totalMargin) / 2 + (this.isLeftAligned ? this.offset : 0)
        if(!this.isLeftAligned) lineX += this.dropdownInformationViews[0].position.x
        for(let i = 0; i < this.numberOfLayers; i++) {
            const line = new SectionBgView(lineX, lineY, lineWidth, lineHeight, this.container, false)
            line.drawBg(GameColor.getColorHexValue(GameColor.Color.GrayScale25), 0.2, 0, undefined, 1, 0)
            line.alpha = 0.2
            this.lineMarkers.push(line)
            lineX += lineWidth + margin
        }
        this.lineMarkers[0].alpha = 1
    }

    private createDropdownInformationView() {
        const dropdownY = this.container.height * 0.05
        const dropdownW = this.container.width * 0.55 - this.offset
        const dropdownH = this.container.height * 0.8
        const dropdownX = this.isLeftAligned ? this.offset : this.container.width * 0.45

        for(let i = 0; i < this.numberOfLayers; i++) {
            const dropdown = new SectionView(dropdownX, dropdownY, dropdownW, dropdownH, this.container, true)
            dropdown.interactive = true
            dropdown.visible = false
            dropdown.on('touchstart', () => this.uiGameManager.eventController.sendEvent(undefined, GameStateEnums.UIGameEventEnums.PlayerInformationViewClicked))
            this.dropdownInformationViews.push(dropdown)
        }
    }

    private incrementActiveLayer() {
        this.dropdownInformationViews[this.currentActiveLayer].visible = false
        this.lineMarkers[this.currentActiveLayer].alpha = 0.2
        this.currentActiveLayer = this.currentActiveLayer + 1
        if(this.currentActiveLayer >= this.numberOfLayers) this.currentActiveLayer = UIPlayerAdditionalInformationLayer.Layer0
        this.dropdownInformationViews[this.currentActiveLayer].visible = true
        this.lineMarkers[this.currentActiveLayer].alpha = 1
    }
}
